import { Route, Routes, BrowserRouter} from 'react-router-dom';
import './App.css';


import Home from './pages/Home';
import Login from './pages/Login';
import Admin from './pages/Admin';
import PrivateRoute from './PrivateRoute';

const basename = process.env.REACT_APP_BASENAME || "/";

const App = () => {
  
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/parceiro" element={<Home parceiro={true} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<PrivateRoute />}>
          <Route path="/admin" element={<Admin />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
